import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CameraIcon, LightbulbIcon, LayoutIcon } from 'lucide-react';
export function ProductPresentation() {
  const benefits = [{
    icon: <LayoutIcon className="w-7 h-7 text-[#0284c7]" data-id="element-232" />,
    title: '+100 diseños exclusivos',
    desc: 'Catálogo completo de modelos probados y listos para fabricar.',
    colSpan: 'md:col-span-2'
  }, {
    icon: <CameraIcon className="w-7 h-7 text-[#0284c7]" data-id="element-233" />,
    title: 'Guía paso a paso con fotos',
    desc: 'Imágenes reales de cada etapa del proceso.',
    colSpan: 'md:col-span-1'
  }, {
    icon: <LightbulbIcon className="w-7 h-7 text-[#0284c7]" data-id="element-234" />,
    title: 'Técnicas LED profesionales',
    desc: 'Secretos de iluminación para un efecto infinito perfecto.',
    colSpan: 'md:col-span-1'
  }, {
    icon: <BookOpenIcon className="w-7 h-7 text-[#0284c7]" data-id="element-235" />,
    title: 'Planos en alta resolución',
    desc: 'Medidas exactas y diagramas de conexión detallados.',
    colSpan: 'md:col-span-2'
  }];
  return <section className="py-32 px-4 relative z-10 bg-white overflow-hidden" data-id="element-236">
      {/* Clean, bright atmosphere - clear sky after storm */}
      <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden" data-id="element-237">
        <div className="absolute top-0 right-0 w-[600px] h-[600px] bg-sky-100/40 rounded-full blur-[150px]" data-id="element-238" />
        <div className="absolute bottom-0 left-0 w-[500px] h-[500px] bg-blue-50/50 rounded-full blur-[120px]" data-id="element-239" />
      </div>

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-240">
        <div className="text-center mb-20" data-id="element-241">
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-sky-50 border border-sky-200 text-sky-700 text-sm font-bold mb-8 tracking-wide" data-id="element-242">
            <div className="w-2 h-2 rounded-full bg-sky-500" data-id="element-243" />
            LA SOLUCIÓN CLARA
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.1
        }} className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-6 tracking-tight leading-[1.1]" data-id="element-244">
            Todo lo que necesitás para{' '}
            <span className="text-[#0284c7]" data-id="element-245">empezar hoy</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="text-xl text-gray-600 max-w-2xl mx-auto font-normal leading-relaxed" data-id="element-246">
            El sistema completo diseñado para llevarte de cero a experto en
            tiempo récord.
          </motion.p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-247">
          {benefits.map((benefit, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.1,
          duration: 0.5
        }} className={`${benefit.colSpan} bg-white border-2 border-gray-100 rounded-3xl p-10 hover:border-sky-200 hover:shadow-[0_20px_60px_rgba(2,132,199,0.08)] transition-all duration-300 flex flex-col gap-6 group`} data-id="element-248">
              <div className="bg-sky-50 w-16 h-16 rounded-2xl flex items-center justify-center border border-sky-100 group-hover:scale-110 group-hover:bg-sky-100 transition-all duration-300" data-id="element-249">
                {benefit.icon}
              </div>
              <div data-id="element-250">
                <h3 className="text-2xl font-bold text-gray-900 mb-3 tracking-tight" data-id="element-251">
                  {benefit.title}
                </h3>
                <p className="text-gray-600 leading-relaxed text-base" data-id="element-252">
                  {benefit.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}